import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useEffect } from 'preact/hooks';
import { useAuth } from '../auth/useAuth';
import { useLocation } from 'preact-iso';
export function RootRedirect() {
    const { isAuthenticated, isLoading, userProfile, allWorkspaces } = useAuth();
    const location = useLocation();
    useEffect(() => {
        if (!isLoading) {
            if (isAuthenticated && userProfile && allWorkspaces) {
                // User is authenticated, redirect to dashboard with proper URL structure
                const clientCompanyId = userProfile.ClientCompanyId;
                // Get workspaces for user's home company
                const homeWorkspaces = allWorkspaces.filter(w => w.ClientCompanyId === clientCompanyId);
                const defaultWorkspaceId = homeWorkspaces.length > 0 ? homeWorkspaces[0].Id : '';
                if (clientCompanyId && defaultWorkspaceId) {
                    location.route(`/company/${clientCompanyId}/workspace/${defaultWorkspaceId}/dashboard`);
                }
                else {
                    // This shouldn't happen in normal flow - user should have company/workspace data
                    console.error('Missing clientCompanyId or companyWorkspaces data for authenticated user');
                    // Redirect to login if we can't construct proper URL
                    location.route('/login');
                }
            }
            else if (!isAuthenticated) {
                // User is not authenticated, redirect to login
                location.route('/login');
            }
        }
    }, [isAuthenticated, isLoading, userProfile, allWorkspaces, location]);
    // Show loading while checking authentication status
    if (isLoading) {
        return (_jsx("div", { className: "min-h-screen bg-slate-50 dark:bg-slate-900 flex items-center justify-center", children: _jsxs("div", { className: "text-center", children: [_jsx("div", { className: "animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600 mb-4" }), _jsx("p", { className: "text-lg text-slate-600 dark:text-slate-300", children: "Loading..." })] }) }));
    }
    // Don't render anything while redirecting
    return null;
}
